export default __webpack_public_path__ + "static/media/minlScreen.e1c70672.svg";